<template>
  <div class="detail-bdi" v-if="scrap" :class="{'detail-bdi-row': showType === 'row', 'detail-bdi-column': showType === 'column'}">
    <div>
      <div class="t-info-text">审批记录</div>
      <record :record-list="scrap && scrap.statusActionRecord ? scrap.statusActionRecord : []"></record>
    </div>
  </div>
</template>

<script>
import record from './record'

import {
  assetsScrapApplyRequest
} from '../../../../api'

export default {
  components: {
    record
  },
  props: {
    id: { type: Number, defualt: null },
    showType: {
      type: String,
      default: 'row'
    }
  },
  watch: {
    id: {
      deep: true,
      handler () {
        this.loadData()
      },
      immediate: true
    }
  },
  data () {
    return {
      scrap: {}
    }
  },
  methods: {
    async loadData () {
      this.scrap = null
      this.purchaseMethodBatchDetailList = []
      if (!this.id) {
        return
      }
      let datas = await assetsScrapApplyRequest.get({
        ids: this.id,
        statusActionRecord: 1
      })
      this.scrap = datas.length > 0 ? datas[0] : null
    }
  }
}
</script>

<style scoped lang="less">
.detail-bdi-row {
  flex-direction: column;
}
.detail-bdi-column {
  flex-direction: row;
}
.detail-bdi {
  display: flex;
  margin: 10px 0;
  .t-info-text {
    font-weight: 600;
    padding: 0 10px;
  }
  .budget-info-2 {
    padding: 5px 10px 0;
    margin-bottom: 10px;
    .info-text-2 {
      font-size: 12px;
      white-space:nowrap;
      line-height: 22px;
      display: flex;
      justify-content: space-between;
      margin-right: 10px
    }
    i {
      color: #FB6D8F;
      padding-left: 10px;
    }
  }
  .p-chart {
    height: 180px;
    display: flex;
    .chart-item {
      width: 150px;
      height: 100%;
    }
  }
}
</style>